module.exports = __webpack_public_path__ + "static/media/instagram.d9704a04.svg";